"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultFastenerWidget_1 = __importDefault(require("./DefaultFastenerWidget"));
exports.default = DefaultFastenerWidget_1.default;
